import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { SubmitOrderForm } from "@/components/forms/easi-recharge/submit-order-form";
import { Button } from "@/components/ui/button";

export default function EasiRechargeSummary() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="space-y-12">
      <SubmitOrderForm />

      <Button onClick={() => navigate(-1)} variant="outline">
        <ChevronLeft />
        <span>{t("labels.back")}</span>
      </Button>
    </div>
  );
}
